import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import "./styles/Status.css";

function StatusTasks(props) {
  if (props.dataArray) {
    const statusDataArray = props.dataArray;
    if (statusDataArray.length == 0) {
      statusDataArray.push({ name: "No Tasks", start: "", end: "", pct: "" });
    }
    return (
      <Box sx={{ textAlign: "center" }}>
        <Box className="statusTableTitle" sx={{ backgroundColor: "darkred" }}>
          Upcoming and Past Due Tasks
        </Box>
        <Table className="statusTable">
          <TableBody>
            <TableRow className="statusTableHeaderRow">
              <TableCell className="statusTableColumnHeader">Name</TableCell>
              <TableCell className="statusTableColumnHeader">Start</TableCell>
              <TableCell className="statusTableColumnHeader">End</TableCell>
              <TableCell className="statusTableColumnHeader">
                Pct Complete
              </TableCell>
            </TableRow>
            {props.dataArray.map((elem, index) => (
              <TableRow key={index} className="statusTableRow">
                <TableCell className="statusTableCell">{elem.name}</TableCell>
                <TableCell className="statusTableCell">{elem.start}</TableCell>
                <TableCell className="statusTableCell">{elem.end}</TableCell>
                <TableCell className="statusTableCell">{elem.pct}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default StatusTasks;

StatusTasks.propTypes = {
  dataArray: PropTypes.array,
};
